import { http } from '@/utils/api'
import { withPbx } from '@/stores/network/api'
import * as Sentry from '@/core/sentry'

export async function updateCallflow(
  inputData: any,
  id: string | number,
  validateOnly = false
) {
  try {
    let params = {}

    if (validateOnly) {
      params = { 'validation-only': validateOnly }
    }

    const url = withPbx(`extensions/${id}/callflow`)

    const { data } = await http.put<CallFlow>(url, inputData, {
      params,
    })

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    return {
      status: 'error' as const,
      payload: error,
    }
  }
}

export type CallFlow = {
  graph?: Record<
    string,
    {
      inports: string[]
      outports: Record<string, string | null>
      parameters: Record<string, any>
      type: string
    }
  >
  callables?: Record<
    string,
    {
      internal_number: string
      type: string
      name: string
      children: {
        internal_number: string
        name: string
      }[]
    }[]
  >
  visual?: Record<
    string,
    {
      x: number
      y: number
      width?: number
      height?: number
    }
  >
  notes?: Record<
    string,
    {
      base64Text: string
    }
  >
  id?: number
  unreachableModules?: never[]
}

export async function loadCallflow(id: string | number) {
  try {
    const url = withPbx(`extensions/${id}/callflow`)

    const { data } = await http.get<CallFlow>(url)

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error: any) {
    if (error.response?.status === 404) {
      return { status: 'success' as const, payload: undefined }
    }

    Sentry.captureException(error)

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}
